import {useContainerBreakpoint} from "@project/layouts";
import {routes} from "@project/router";
import {Navigate, createFileRoute, useParams} from "@tanstack/react-router";
import {useRef} from "react";

import {Route as ClientRoute} from "./route";

export const Route = createFileRoute("/_app/sales/clients/$clientId/")({
  component: IndexRouteComponent,
});

function IndexRouteComponent() {
  const {clientId} = useParams({strict: false}) as {clientId: string};
  const {includeDeleted} = ClientRoute.useSearch();
  const ref = useRef<HTMLDivElement>(null);
  const isDesktop = useContainerBreakpoint(ref);

  if (isDesktop) {
    return (
      <Navigate
        replace
        params={{clientId}}
        search={{
          page: 1,
          perPage: 10,
          q: undefined,
          sortBy: "editedAt",
          sortDir: "desc",
          includeDeleted,
        }}
        to={routes.sales.clients.client().contacts()}
      />
    );
  }

  return <div ref={ref} className="h-full w-full" />;
}
